export type TelegramTokenInputClassification = 'link' | 'username' | 'token_like' | 'unrecognized';

const LINK_PATTERN =
  /^(?:(?:https?:\/\/)?(?:www\.)?(?:t\.me|telegram\.me|telegram\.dog)\/|tg:\/\/resolve)/i;
const AT_USERNAME_PATTERN = /^@[A-Za-z0-9_]{4,32}$/;
const BOT_USERNAME_PATTERN = /^[A-Za-z][A-Za-z0-9_]{1,28}bot$/i;
const TOKEN_PATTERN = /^\d+:[A-Za-z0-9_-]{30,}$/;

export const classifyTelegramTokenInput = (raw: string): TelegramTokenInputClassification => {
  const value = raw.trim();
  if (LINK_PATTERN.test(value)) return 'link';
  if (AT_USERNAME_PATTERN.test(value) || BOT_USERNAME_PATTERN.test(value)) return 'username';
  if (TOKEN_PATTERN.test(value)) return 'token_like';
  return 'unrecognized';
};
